module.exports = __webpack_public_path__ + "static/media/worldcover_logo_v2.dafedc35.svg";